module.exports = __webpack_public_path__ + "src/assets/textures_low/molar/spoon1.jpg";